import React from "react";
import { StuVoteItem, VoteContent } from "service/vote";

interface VoteSelectInfo {
    voteInfo: VoteContent;
    data: StuVoteItem;
}

export default function VoteSelect({ voteInfo, data }: VoteSelectInfo) {
    function getText(text: string) {
        if (text === "1") return "YES";
        if (text === "0") return "NO";
        return text;
    }

    return (
        <div>
            {data.voteStatus === "0" && (
                <span style={{ color: "#FE2F3E" }}>--</span>
            )}
            {data.voteInfo?.map(item => getText(item.content)).join("、")}
        </div>
    );
}
